import sharedCardData from "./CardData-shared"

const cards = [
  {
    id: 1,
    mainBenefit: [
      "Earn unlimited 2x miles on all purchases, with 10x miles on hotels and rental cars booked through Capital One Travel.",
      "$300 annual credit for travel bookings made through Capital One Travel.",
      "Get 10,000 bonus miles (equal to $100 towards travel) every year, starting on your first anniversary.",
      "Receive up to a $120 statement credit every four years for Global Entry or TSA PreCheck.",
      "Enjoy enhanced benefits with a complimentary upgrade to Hertz President’s Circle® status.",
      "Enjoy complimentary access to Capital One Lounge locations and our in-airport culinary experience, Capital One Landing.",
      "Enjoy unlimited access for you and 2 guests to the Capital One Partner Lounge Network and, after enrollment, complimentary membership to Priority Pass™.",
      "Comes with primary rental car insurance, meaning it applies before your personal auto insurance. This benefit reimburses up to $75,000 for damage or theft to a rental car.",
    ],
    costBreakdown: [
      { description: "Annual Fee", amount: 395 },
      { description: "Capital One Travel Credit", amount: -300 },
      { description: "Annual Bonus Miles", amount: -100 },
      { description: "Final Annual Cost", amount: -5 },
    ],
    whyKeep: [
      "这个卡是有年费卡中非常适合长期持有的。每年年费395，但是返还300的travel credit, 同时每年还送10000点，基本相当于免费。Travel credit可以在capital one travel订酒店，租车，买机票等，300会在预定的时候直接减掉，也不需要一次用完，非常方便。另外capital one travel提供price match，如果你在外面找到任何比capital one travel便宜的价格，打电话过去很快就match了。",
      "日常消费，这个卡返点2x miles，相当于2% cashback，在capital one travel定travel相关，返点10x miles。唯一要注意的是，如果想把点直接apply到信用卡上，只能cover travel相关的transaction，不是所有transaction都可以。",
      "对旅游来说，这张卡包含了免费的<strong>capital one lounge access</strong>和<strong>Priority Pass</strong>，每次可以带两名同伴一起进lounge。（2026年2月开始，Capital one卡不再支持带同伴进lounge。 ）如果经常旅游，想长期保留一张priority pass，这张卡是很不错的选择。",
      "这张卡同时还提供了<strong>complimentary Hertz President’s Circle® status</strong>. 这个相当于Hertz中最高的membership level，可以享受免费升级，取车的时候无需等待，如果对应机场有president circle的lot，直接过去可以开lot内任意有的车，基本上租车可以选择最便宜的车型，到机场找喜欢的车即可，非常方便.",
      "另外这张卡和其他卡不同的还有<strong>primary rental car insurance coverage</strong>. 很多信用卡提供租车保险，都是secondary coverage，意思是你自己的保险需要先支付，才到信用卡公司保险支付. 这张卡提供primary coverage，在你自己的保险激活之前包含最高75000的保险，这样可以最大限度的减少对你自己保险的影响，非常方便。",
      "信用卡积累的点数除了可以直接用来涵盖旅游相关支付，还可以转到很多航空公司和酒店，包含Air France, Jetblue, Aeromexico, Air Canada, Cathay, All-Accor Live Limitness, Avianca Lifemiles, British Airway, Choice Privileges, mirates, Etihad Airways, EVA Air, Finnair, Qantas, Singapore Aireline, TAP Miles, Turkish Airline, Virgin Red 和 Wyndham Rewards。",
      "这张卡历史最高bonus是10万点，但是正常情况都是75000点bonus，相当于750$。如果感兴趣在75000点及以上都可以考虑。",
    ],
  },
  {
    id: 2,
    mainBenefit: [
      "Earn 14x points on Hilton hotels, 7x points on dining, and 3x points on all other purchases.",
      "Complimentary Hilton Diamond Status",
      "$400 Hilton Resort Credit (Enjoy up to $200 in statement credits semi-annually on eligible purchases made directly with participating Hilton Resorts using your Hilton Honors Aspire Card)",
      "Hilton Free Night Reward",
      "$200 Flight Credit (Receive up to $200 back per year (Up to $50 in statement credits each quarter) on eligible flight purchases.)",
    ],
    costBreakdown: [
      { description: "Annual Fee", amount: 550 },
      { description: "Hilton Resort Credit", amount: -400 },
      { description: "Free Night Value", amount: -250 },
      { description: "Flight Credit", amount: -200 },
      { description: "Final Annual Cost", amount: -300 },
    ],
    whyKeep: [
      "这张卡适用于每年出去旅游两次以上，而且喜欢Hilton酒店的家庭，如果能够充分利用卡的benefit，最终不光年费可以拿回来，还能倒赚一些。首先这张卡提供Complimentary Hilton Diamond Status，这两年Hilton Status缩水比较严重，由于有status的人过多，不是经常可以得到免费房间升级。但是在美国之外还是非常不错，美国以外Hilton提供房间内成年客人的免费早餐，在美国国内可以选择拿bonus point或者每个成年人每天15$的credit，这个15$ credit必须当天用完，没法叠加.",
      "每年该卡提供一个免费的free night certificate，可以用于预定Hilton系列酒店的standard room。这个certificate非常好用，不同于其他酒店经常有各种点数限制，这个certificate可以用于hilton系列各类酒店，只要有standard room即可，比如纽约中央公园附近的Hilton。唯一的限制是必须一年内使用，过期作废。",
      "另外一个非常好的benefit是$400 Hilton Resort，每半年200，如果不用就作废了。 所有<a href='https://www.hilton.com/en/p/hilton-honors/resort-credit-eligible-hotels/'>https://www.hilton.com/en/p/hilton-honors/resort-credit-eligible-hotels/</a>上的酒店都可以使用，包括了房费以及在酒店内的各种消费，一般支付过之后一到两周就refund到信用卡，如果没有收到在线和客服chat一下，很快就拿到了。",
      "AMEX卡还提供了$200 Flight Credit, 每个季度$50。不同于其他大部分卡机票不qualify，只能用于托运行李，升级，飞机上购买食品等。这张卡涵盖了机票，而且不和任何航空公司绑定，如果在季度内使用本卡购买任何机票，很快就会收到50$的退款。如果你不需要在季度内旅游，可以考虑购买southwest的机票，southwest的机票可以随时取消，换成credit，这样可以不错过信用卡的福利。",
      "如果经常出游，且能利用上大部分的benefit，这张卡是很不错的选择。一般bonus在15万以上，都是非常不错的deal，可以考虑申请。",
    ],
  },

  {
    id: 3,
    mainBenefit: [
      "Marriott Bonvoy® Platinum Elite Status",
      "Priority Pass™ Select",
      "25 Elite Night Credits towards the next level of Marriott Bonvoy® Elite status",
      "Each calendar year, get up to $300 (up to $25 per month) in statement credits for eligible purchases made on the Card at restaurants worldwide",
      "Receive 1 Free Night Award (redemption level at or under 85,000 Marriott Bonvoy® points) every year after your Card renewal month.",
      "Earn 6x points at Marriott hotels, 3x points on dining, and 2x points on all other purchases.",
      "Fee Credit for Global Entry or TSA PreCheck",
    ],
    costBreakdown: [
      { description: "Annual Fee", amount: 650 },
      { description: "Free Night Value", amount: -350 },
      { description: "Restaurant Credit", amount: -300 },
      { description: "Final Annual Cost", amount: 0 },
    ],
    whyKeep: [
      "这张卡适合喜欢Marriott并且经常旅游的家庭，最大的benefit是Marriott Bonvoy® Platinum Elite Status, 这个通常需要每年住宿50晚以上才可以拿到，有了platimum elite status以后，除了bonus point，late checkout，房间升级以外，最大的好处是包含了早餐，在有club的酒店通常还包含club access，比如boston MIT的marriott就包含了早餐，下午茶，以及晚上甜点等服务. 如果住courtyard等没有lounge的酒店，可以选择拿500 bonus point，或者每人15$的food credit，建议每人拿15 credit，通常基本可以cover早餐cost了。",
      "虽然这张卡年费比较高，但是每年会返还$300 restaurant credit，这部分每个月返还25，没法叠加，如果当月未用就浪费了。使用的时候只要用卡在任何饭店，快餐店刷卡就可，不需要一次购买25以上。刷过以后几天会返还到卡上。",
      "另外一个benefit是The annual Free Night Award，这张certificate可以用于预定up to 85,000 Marriott Bonvoy® points的酒店房间, 这个点位可以预定很多通常需要$700-$800的房间，如果用的上非常划算。但是和其他卡类似，需要在一年以内用掉，不然就作废了。",
      "除了上面的benefit，这张卡同样包含了Priority Pass™ Select membership和25 Elite Night Credits. 如果能够用的上free night award，还是非常值得拥有的。",
      "这张卡sign on bonus变动很大，建议在有15万以上的bonus的时候申请。",
    ],
  },
  {
    id: 4,
    mainBenefit: [
      "4X points at restaurants worldwide (up to $50K in purchases per year).",
      "4X points at U.S. supermarkets (up to $25K in purchases per year).",
      "$120 Uber Cash annually ($10/month for Uber or Uber Eats).",
      "$120 Dining Credit annually for Grubhub, Cheesecake Factory, and more.",
      "$84 Dunkin’ Credit annually ($7/month).",
      "$100 Resy Dining Credit annually ($50 twice a year).",
      "$100 Hotel Collection credit on eligible two-night stays via AmexTravel.com.",
    ],
    costBreakdown: [
      { description: "Annual Fee", amount: 325 },
      { description: "120 Uber Cash", amount: -120 },
      { description: "120 Dining Credit", amount: -120 },
      { description: "84 Dunkin Credit", amount: -84 },
      { description: "100 Resy Credit", amount: -100 },
      { description: "Final Annual Cost", amount: -99 },
    ],
    whyKeep: [
      "这张AMEX Gold卡虽然有325的年费，但是如果能够用到所有的benefit，还是可以把所有年费拿回来的。这个卡最吸引人的就是Grocery shopping还有餐馆都是4x points，就是自动4% cashback",
      "每年有<strong>$120 Uber Cash</strong>, 每个月10刀，可以用来打车，也可以用来uber eat。因为是uber cash，所以可以和其他的offer叠加，比如买一送一啥的，还是很容易用掉的。",
      "另外每年还有<strong>$120 Dining Credit</strong>, 也是每个月10刀，可以用于Grubhub, The Cheesecake Factory, Goldbelly, Wine.com, and Five Guys. 中午买个汉堡就用掉了，另外Grubhub是类似uber的外面平台，好处是可以选择pick up，这样就不用付各种费用，也是不错选择。",
      "对于喜欢喝咖啡的朋友，这个卡每年有<strong>$84 Dunkin’ Credit</strong>，每个月7刀，所有上面的这些credit都需要当月用掉，不然就浪费了. 这个最简单的做法就是每个月在dunkin app里面reload 7$ gift card balance就可以了。",
      "另外每年还有<strong>$100 Resy Dining Credit</strong>, 每半年50刀。<a href='https://resy.com'>Resy.com</a>上面有很多的餐厅，只要去餐厅吃饭的时候用这张卡付费就自动返回50了，这个是最容易用掉的benefit。",
      "另外还有一个<strong>$100 hotel credit</strong>，但这个需要在<em>amextravel.com</em>上面订至少两晚，旅店选择有限，相对较难用掉，就不列在上面的cost breakdown里面了",
      "这个卡经常会有target offer，开户10万点，一般的offer都是6万点。如果超过6万都可以考虑申请",
    ],
  },
  {
    id: 5,
    mainBenefit: [
      "Earn 3x points on dining, 2x points on travel, and 1x points on other purchases.",
      "A $100 annual credit on hotel stays purchased through Chase.",
      "Hotel and airline transfer partners.",
      "Each account anniversary, cardmembers will earn bonus points equal to 10% of total purchases made the previous year.",
    ],
    costBreakdown: [
      { description: "Annual Fee", amount: 95 },
      { description: "Hotel Credit", amount: -100 },
      { description: "Final Annual Cost", amount: -5 },
    ],
    whyKeep: [
      "Chase有年费卡中讨论最多的就是这张CSP (Chase Sapphire Preferred) 和 <a href=6>CSR</a> (Chase Sapphire Reserve)。Chase点数最好的地方在于可以转点到它的travel partner，但是绝大多数的无年费卡并不支持转点，所以需要保留一张卡，这样你就可以把所有其他chase卡的点转到一起。",
      "Chase的Travel partner包含Marriott, Aer Lingus, Air Canada, British Airways, Emirates, Air France, Iberia, Jetblue, Signapore Airlines, Southwest, United, Virgin Atlantic, IHG Hotel & Resorts, Hyatt",
      "CSP就是相对成本最低的卡，这个卡虽然有95的年费，但是每年提供<strong>$100 annual hotel credit</strong>。只需要用这张卡在chase travel预定任何hotel，都会在几天后收到100的credit。如果当年没用，就浪费了。但是因为Chase travel选择很多，所以一般很容易用掉。",
      "和CSR类似，CSP外出吃饭也提供<strong>3x points on dining</strong>, 一般认为Chase点数价值1.6，所以就相对应大概吃饭4.8% cashback.",
      "CSP每年最后还提供<strong>10% anniversary bonus</strong>, 如果你全年消费超过50000点，基本上就可以把支付的50块钱拿回来了。如果不愿意支付<a href=6>CSR</a>的年费，这张CSP是一个可以长期保留的选择。",
      "这张卡在刚推出的时候有过10万点的sign on bonus，但之后大多数时间都是6万点左右，如果sign on bonus在6万点都可以考虑申请",
    ],
  },
  {
    id: 6,
    mainBenefit: [
      "Earn 3x points on dining and travel, with $300 in annual travel credits.",
      "Airport lounge access for Priority pass and Chase Lounge ",
      "Shopping protection and extended warranty ",
      "Free DashPass membership ",
      "Hotel and airline transfer partners.",
      "TSA PreCheck/Global Entry/NEXUS credit",
      "50% more value when redeeming for travel",
    ],
    costBreakdown: [
      { description: "Annual Fee", amount: 795 },
      { description: "300$ Travel Credit", amount: -300 },
      { description: "300$ Dining Credit", amount: -300 },
      { description: "500$ Edit Selection Hotel", amount: -500 },
      { description: "300$ Stubhub Credit", amount: -300 },
      { description: "300$ DoorDash Credit", amount: -300 },
      { description: "Final Annual Cost", amount: -905 },
    ],
    whyKeep: [
      "Chase有年费卡中讨论最多的就是这张 CSR (Chase Sapphire Reserve)和 <a href=5>CSP</a> (Chase Sapphire Preferred). 这张CSR年费较高，持卡有成本。Chase点数最好的地方在于可以转点到它的travel partner，但是绝大多数的无年费卡并不支持转点，所以需要保留一张卡，这样你就可以把所有其他chase卡的点转到一起。",
      "Chase的Travel partner包含Marriott, Aer Lingus, Air Canada, British Airways, Emirates, Air France, Iberia, Jetblue, Signapore Airlines, Southwest, United, Virgin Atlantic, IHG Hotel & Resorts, Hyatt",
      "和<a href=5>CSP</a>类似，这张卡支持转点到travel partner，但是持卡成本较高。相对于CSP，最大的好处是用chase point在chase travel预定时，有50% more value，如果你不打算转点到travel partner，这会大大提高直接使用点数的value",
      "这张卡同时还提供complimentary lounge access，包含了常见的priority pass和Chase Lounge。一般的priority pass只能一年去chase lounge一次，有了这种卡就没有任何限制了，如果你所在的机场有Chase lounge，这是一个很好的benefit。除此之外这张卡还提供每四年一次的100$ <strong>TSA PreCheck, Global Entry, or NEXUS fee credit</strong>",
      "和CSP类似，CSR外出吃饭也提供<strong>3x points on dining</strong>, 一般认为Chase点数价值1.6，所以就相对应大概吃饭4.8% cashback.",
      "目前这张卡还提供<strong>free DashPass membership</strong>，而且每个月有20$ doordash grocery credit和5$ restaurant credit，如果有需求还是很不错的。对于大多数的grocery store因为只有delivery option，所以这个10$ coupon用处不大，最好的方法是选择grocery store的deli，这样就可以选择pick up选项了，比如local的safeway deli，10$基本可以解决一顿中午饭。这样就不会浪费每年240的grocery credit了。这张卡持卡每年有成本，如果上面说到的benefit用的上，可以考虑申请，用不上的话可以优先考虑 <a href=5>CSP</a> ",
      "这张卡最近刚把年费从550增加到了795，同时添加了一些新的benefit。对于用的上benefit的，新卡实际成本大大降低。但是很多新的benefit有点类似coupon book，使用难度实际大大增加了。",
      "每年有500$ credit用于Chase Edit Selection Hotel，每半年有250，但是每次至少要住2个晚上，Edit Selection的酒店属于Luxury系列, 价格不菲。如果不是正好用的上，这一项benefit相对较难每年使用上。 喜欢Las Vegas的朋友，这个benefit还是非常不错的， 除了credit之外，而且通常100 Property Credit和双人早餐， 250的价位已经可以在MGM之类酒店住两天了。",
      "每年有300$ dinning credit，每半年150，相对于上面的500，这个相对容易。但是只能用于符合要求的饭店，具体list可以参考<a href='https://www.opentable.com/c/chasedining/'>https://www.opentable.com/c/chasedining/</a>",
      "每年有免费的Apple Tv + Apple Music，价值250。另外还有免费的IHG One Rewards Platinum Elite Status",
      "每年有300的stubhub credit，每半年150，这一部分主要是用于定体育比赛或者演唱会。",
      "每个月有10$ lyft credit，全年一共120，适合经常有打车需求的",
      "每年使用超过$75000之后，会另外添加250 Chase shopping credit，500$ southwest travel credit，加上IHG One Reward Diamond Elite Status，以及Southwest A List Status。",
    ],
  },
  {
    id: 7,
    mainBenefit: [
      "Earn unlimited 3% back on your Amazon and Whole Foods purchases or 5% back with an eligible Prime membership*",
    ],
    costBreakdown: [],
    whyKeep: [
      "如果你经常在Amazon或者whole foods购物，Amazon Prime Visa Card非常值得和Prime membership一起拥有.",
      "这张卡没有年费，如果你有prime membership，所有Amazon和whole foods的购物都有5% cashback。而且所有cashback可以直接用到Amazon之后的购买，cashback第二天就到账，非常方便。",
      "这张卡来自chase，如果申请，要注意chase的5/24 rule，就是24个月内不能申请超过5张新卡",
      "申请这张卡的bonus一般都是100，年末促销的时候，有时Amazon会把bonus提高到150。在prime day促销的时候，最高出现过250的bonus。总体来说，如果有需要，正常offer就可以考虑，毕竟购买的如果多，早点拿到cashback好过多等这50$ bonus",
    ],
  },
  {
    id: 8,
    mainBenefit: [
      "$75 dollars Southwest® annual travel credit",
      "7500 points every year on your cardmember anniversary",
      "4 upgraded boarding per year when available",
      "10,000 Companion Pass qualifying points boost",
      "Earn 3x points on Southwest purchases, 2x on hotel, car rental, internet, phone and 1 point for all other purchase",
    ],
    costBreakdown: [
      { description: "Annual Fee", amount: 229 },
      { description: "75$ Travel Credit", amount: -75 },
      { description: "7500 points", amount: -75 },
      { description: "Final Annual Cost", amount: 79 },
    ],
    whyKeep: [
      "Southwest是非常独特的航空公司，买票非常flexible，购票以后在网站上随时可以price match，而且取消票也非常方便，没有额外费用。如果你所在机场有southwest，非常强烈推荐。Southwest中最吸引人的就是Southwest Companion Pass，你如果有了Companion pass，无论去哪里，都可以带你指定的Companion，只需要每一段支付5.6$即可。账户内companion每年可以修改3次。",
      "购买southwest机票，和其他航空公司不同，只要航程定了，就可以马上出票，无需等待便宜机票。因为有了便宜的价格，随时可以退回差价，他们的系统设计的非常好，无需联系客服，只需到网页找到已有的票，选择修改，然后选择同一个航班，差价就自动退回到账户了。",
      "如果你对southwest感兴趣，会乘坐southwest飞机，这张卡是一个很好的选择。虽然有149的年费，但是每年在southwest购票有75$ credit，用这张卡支付即可。同时每年会收到 7,500 Rapid Rewards points，这样就基本免费了。这张卡2025年7月份开始年费涨到了229，目前持卡成本79$. 如果单纯是为了积累southwest的点数，就不是非常划算了，可以考虑免费的<a href=13><strong>Bilt Card</strong></a>",
      "如果申请这张卡的主要目的是拿到southwest companion pass，那么建议在年初申请，或者在有special companion pass offer的时候。每年chase会有几次special offer，申请这张卡就可以拿到大概一年的免费companion pass。在没有special offer的时候，要拿到companion pass，需要积攒135000点。这张卡通常可以拿到50000点左右，需要同时申请一张<a href=9><strong>Chase Southwest Rewards Performance Business Card</strong></a>，两张卡加到一起就可以满足要求了。在非special offer时期拿到的southwest companion pass，会从拿到那一天到下一年年底到期。所以建议在年初的时候申请，比如你在2025年一月满足要求，拿到了companion pass，这样可以持有到2026年12月底。",
      "另外一个benefit是每年有4次免费升舱，升舱需要在起飞前24小时apply，并不是每一个航班都有升舱名额。southwest根据距离远近，升舱价格并不同，但是对于这个卡没有区别，升舱之后都会自动返还。",
      "如果打算长期持有，这个卡每年还有<strong>10,000 Companion Pass qualifying points</strong>，当然如果没有sign on bonus，那需要刷卡很多才能满足要求。对于经常飞southwest的乘客，可以考虑长期持有，也可以考虑拿到bonus一年内取消，卡取消之后24个月再次申请，就可以再次拿同样的bonus。但是请勿滥用，Chase会根据情况，一旦进去黑名单，就再也无法申请任何Chase的卡了。",
      "这张卡通常sign on bonus为5万点，如果有special companion pass offer，通常点数会稍微少一些。建议在有special offer的时候，或者点数超过5万点的时候申请。special offer的好处是只需要申请一张卡，但是坏处是拿到的companion pass时间相对较短，一般只有一年左右，大家可以根据自己的情况取舍。",
    ],
  },
  {
    id: 9,
    mainBenefit: [
      "Up to 365 inflight WiFi Credits per year",
      "9000 points every year on your cardmember anniversary",
      "4 upgraded boarding per year when available",
      "Earn 1,500 tier qualifying points toward A-List status for every $5,000 spent",
      "Up to $120 Global Entry, TSA PreCheck® or NEXUS fee credit every 4 years",
      "Earn 4x points on Southwest flights and 3x on travel, dining and 1 point for all other purchase",
    ],
    costBreakdown: [
      { description: "Annual Fee", amount: 299 },
      { description: "9000 points", amount: -90 },
      { description: "Final Annual Cost", amount: 209 },
    ],
    whyKeep: [
      "Southwest是非常独特的航空公司，买票非常flexible，购票以后在网站上随时可以price match，而且取消票也非常方便，没有额外费用。如果你所在机场有southwest，非常强烈推荐。Southwest中最吸引人的就是Southwest Companion Pass，你如果有了Companion pass，无论去哪里，都可以带你指定的Companion，只需要每一段支付5.6$即可。账户内companion每年可以修改3次。",
      "购买southwest机票，和其他航空公司不同，只要航程定了，就可以马上出票，无需等待便宜机票。因为有了便宜的价格，随时可以退回差价，他们的系统设计的非常好，无需联系客服，只需到网页找到已有的票，选择修改，然后选择同一个航班，差价就自动退回到账户了。",
      "如果你对southwest感兴趣，会乘坐southwest飞机，可以考虑申请<a href=8><strong>Southwest personal card</strong></a>和这张卡。如果你的目的是拿到companion pass，但只想申请一张卡，可以考虑在<a href=8><strong>Southwest personal card</strong></a>有special offer的时候申请。",
      "如果申请这张卡的主要目的是拿到southwest companion pass，而且不考虑special offer, 那么建议在年初申请，要拿到companion pass，需要积攒135000点。<a href=8><strong>Southwest personal card</strong></a>通常可以拿到大概5万点，这张卡通常可以拿到80000点左右，两张卡加到一起就可以满足要求了。在非special offer时期拿到的southwest companion pass，会从拿到那一天到下一年年底到期。所以建议在年初的时候申请，比如你在2025年一月满足要求，拿到了companion pass，这样可以持有到2026年12月底。",
      "另外一个benefit是每年有4次免费升舱，升舱需要在起飞前24小时apply，并不是每一个航班都有升舱名额。southwest根据距离远近，升舱价格并不同，但是对于这个卡没有区别，升舱之后都会自动返还。",
      "和个人卡不同，这张卡还提供飞机上免费上网，只需要用这张卡付费即可，在同一个航班也可以给多人购买wifi，每年最多不超过365次即可。这张卡每年还提供<strong>9,000 points on your cardmember anniversary</strong>, 但是和个人卡相比，还是有持卡成本，可以根据个人情况选择是不是要保留。如果不保留，卡取消之后24个月再次申请，就可以再次拿同样的bonus。但是请勿滥用，Chase会根据情况，一旦进去黑名单，就再也无法申请任何Chase的卡了。",
      "Business card还提供了每4年一次的<strong>Global Entry, TSA PreCheck®, or NEXUS fee credit</strong>, 最多到120$",
      "这张卡sign on bonus最高为12万点，但是通常在8万点以上，都可以考虑申请。",
    ],
  },
  {
    id: 10,
    mainBenefit: [
      "Earn 3% cashback in a category of your choice and 2% on groceries on the first $2,500 in combined purchases each quarter.",
      "Bank of America Preferred Rewards® members earn 25%-75% more cash back on every purchase.",
    ],
    costBreakdown: [],
    whyKeep: [
      "这张卡非常适合<strong>Bank of America Preferred Rewards® member</strong>，如果你在Bank of America和Merrill股票账户中有超过10万存款，这张卡绝对适合你. 尤其是如果你在Merrill有退休账户，10万的要求是很容易达到的。",
      "Bank of America有两张不同的卡，一张是所有purchase都1.5% cashback，另外一张就是这个，每个季度，可以选择一个category, 前2500$有3%的cashback，其中最好的category是online shopping，基本所有的online purchase都qualify。",
      "根据你的<strong>Bank of America Preferred Rewards® member</strong> status，你可以拿到25%, 50%, 或者75%的bonus。如果你有plantium status (with $100,000 or more in combined assets across Bank of America and Merrill accounts), 就可以拿到75% bonus，这样之前的3%就变成了<strong>5.25% cashback</strong>. 作为没有年费的卡，这已经是非常好的福利了。唯一的限制是每个季度有2500的上限，如果你消费比较多，也可以考虑另外一张1.5%的卡，这样加上bonus就是一张所有消费2.625% cashback的卡。",
      "所有你挣到的点数，可以直接用来自动支付信用卡账单，非常方便。",
    ],
  },
  {
    id: 11,
    mainBenefit: [
      "Earn 2% cashback on all purchases, deposited into your Fidelity account.",
      "Credit of up to 10,000 Reward Points (worth up to $100) every four years for the Global Entry or TSA PreCheck application fee, when you pay with the card",
    ],
    costBreakdown: [],
    whyKeep: [
      "如果你是Fidelity的客户，这张卡作为一张简单好用的2% cashback卡，还是非常推荐的. 每年可以挣的点数没有限制，但是点数需要deposit到<a href='https://www.fidelity.com/spend-save/fidelity-cash-management-account/overview'>Fidelity cash management</a>账户，需要开一个对应的账户。这个cash management账户有ATM card，可以在任意bank的ATM取钱，如果其他bank有charge费用，费用会作为rebate自动退回到你的账户，非常方便。",
      "作为没有年费的卡，这张卡还有一个非常unique的benefit, 每四年有100$的Global Entry or TSA PreCheck application fee credit。这个benefit通常是在有年费的卡中才有，如果你不希望申请有年费的卡，又希望免费申请TSA Pre，这张卡是很不错的选择",
    ],
  },
  {
    id: 12,
    mainBenefit: [
      "Earn 5% cash back on different categories on up to $1,500 in total combined purchases each quarter ",
      "3% on DINING at restaurants, including takeout and eligible delivery services",
      "3% on DRUGSTORE purchases",
    ],
    costBreakdown: [],
    whyKeep: [
      "Chase Freedom Flex Card是无年费chase卡中非常好的选择，每个季度都会有一个category提供<strong>5% cashback</strong>, Chase会在每个季度开始前公布，需要enroll一下，这样前1500$消费会有5% cashback，经常有的类别如吃饭加油等.",
      "在5% cashback category之外，这张卡吃饭cashback为3%,  一般认为Chase点数价值1.6，所以就相对应大概吃饭4.8% cashback. 但是请注意这张卡的点没法直接转到chase travel partner, 如果有需求，需要申请一张<a href=5>CSP (Chase Sapphire Preferred)</a> 或者<a href=6>CSR (Chase Sapphire Reserve)</a> ",
      "这张卡无年费，而且5% cashback，如果考虑到chase点数1.6，就大概相当于每个季度有1500可以8% cashback，还是相当值得拥有的。",
    ],
  },
  {
    id: 13,
    mainBenefit: [
      "Earn points on rent and mortgage payments with no transaction fee — up to 100,000 points per year.",
      "New 'Flexible Bilt Cash' option: Earn 4% cash back on everyday spend to unlock housing points.",
    ],
    costBreakdown: [],
    whyKeep: [
      "Bilt信用卡现由 <strong>Cardless</strong> 银行发布，<strong>无年费</strong> 版本（Bilt Blue）依然保留。这是目前市场上极少数能将大额生活支出（房租/房贷）转化为高价值里程点的工具。同时提供了两种不同的收年费的卡option，Bilt Obsidian Card（年费 $95）和 Bilt Palladium Card（年费 $495）。",
      "简单比较一下三种卡，无年费卡所有消费返点1%, 如果想房租房贷积分，有两种方式，第一种方式是选择房租房贷积分选项，房租积分最高1.25x，每个月需要消费和你房贷数额一样的金额才能拿到1.25x，其实就是相当于一个2.25%返点的卡。第二种方式是选择日常消费返4% Bilt Cash， 如果消费较多，这种可能更划算，房贷每1000 point需要消费30$ Bilt Cash，但是最多1x。",
      "第二张卡和之前的Bilt Card类似，有95年费，日常消费1x，旅游2x，餐饮3x。房租房贷积分和无年费卡一样，但是每年会自动送100$ Bilt Cash。",
      "第三张卡有495年费，所有消费都是2x。房租房贷积分和无年费卡一样，每年会自动送200$ Bilt Cash。同时还送400 Bilt Hotel Travel Credit，这个每半年200，可以用来预定酒店。",
      "个人推荐495年费的卡，加上4% Bilt Cash。我们来简单计算一下，这个是2% + 4% bilt cash，最终的比例就取决于这4% bilt cash到底值多少钱。Bilt Cash有不同的使用方式，每个方式对应的比例不同。首先是每个月可以兑换10$ walgreen和10$ grubhub gift card，这个因为是gift card，没有过期时间，相当于把Bilt Cash一比一兑现了，不要错过。第二是每个月都可以订酒店使用，一般用户是每个月可以用50 Bilt Cash，gold member可以用100 Bilt Cash。如果使用495年费的卡，到了需要花费的数额就自动变成Gold Status，这个部分可以和上面的Bilt Travel Credit叠加。但是记得两个都要求至少预定2晚，这样相当于每半年可以预定300的两晚酒店，不用花钱了。另外这个100 Bilt Cash是每个月都可以用的，对于经常旅游的家庭非常不错。Bilt Cash还有很多其他用处，比如每个月10$ Lyft, $25 credit for bilt dining partner，这个能用到的不多，就不再细说了。",
      "上面所说的方式，基本是Bilt Cash 1-1兑现了，但是毕竟数量有限，不可能所有都用掉。更多的是两种，如果兑现到房贷，如前所讲，每1000房贷需要30 Bilt Cash，这样大概相当于3-1的比例，就是把这4%换成了1.13%，加上之前的2%，就是大概3.13%的样子，明显好于之前的2.25%返点，当然这种也有上限，不可能超过你实际房贷的数量。还有一个常用的方式是Point Accelerator，花费200 Bilt Cash可以把之后的5000消费变成返点3x，这个相当于把4%变成了1%，加上之前2%，相当于一个所有3%的卡，Bilt Cash用不完的可以考虑。整体来说，选择Bilt Cash，至少也有3%的返点，鉴于这个是适用于所有purchase，还是相当有吸引力的。",
      "Bilt 2.0 时代最大的升级是全面支持 <strong>房贷 (Mortgage)</strong> 支付且 <strong>不收手续费</strong>。每年最高可赚取 <strong>100,000 点积分</strong>。目前支持绝大多数主流贷款机构，包括：Chase, Bank of America, Wells Fargo, Rocket Mortgage, United Wholesale Mortgage 等。",
      "<strong>奖励机制二选一：</strong> 用户可以在 App 中选择 'Housing-only'（自动获得房租积分，最高 1.25x）或 'Flexible Bilt Cash'（日常消费返 4% Bilt Cash，再以 $30 Bilt Cash 兑换 1,000 积分的比例解锁房贷/房租积分）。这种设计更灵活，适合消费习惯不同的用户。",
      "<strong>支付流程：</strong> 依然通过 Bilt App 获得 <strong>虚拟支票账户 (Virtual Checking Account)</strong>。将该账户绑定至你的房贷支付系统（ACH转账），Bilt 会自动从你绑定的银行账户扣款并累计积分，不会占用信用卡额度。",
      "<strong>授权机制：</strong> 支付房贷前需在 App 中进行 <strong>Authorize</strong> 操作以确保安全。建议开启 <strong>Auto-authorize</strong> 功能，针对每月固定金额的房贷自动授权，实现自动化赚分。",
      "<strong>租金日 (Rent Day)：</strong> 每月 1 号所有消费积分翻倍（房租除外），最高可额外获得 <strong>1,000 点积分</strong>。此外，Rent Day 经常提供极高倍率的转点奖励（如 100% Transfer Bonus）。",
    ],
    bonus: "50,000 Bilt Points and Gold Elite Status",
    historicHighestBonus: "50,000 Bilt Points and Gold Elite Status",
  },
  {
    id: 14,
    mainBenefit: [
      "通过 Amex Travel 预订航班和预付酒店可获得 5 倍积分。",
      "享受全球 1,550+ 机场贵宾室，包括 Centurion 贵宾室、Priority Pass、Delta Sky Club 等。",
      "每年最高 $600 的 Fine Hotels + Resorts 或 The Hotel Collection 酒店预订信用。",
      "每年最高 $100 的 Saks Fifth Avenue Credit（每半年 $50）。",
      "每年最高 $400 的 Resy 餐饮信用（每个季度 $100）。",
      "每年最高 $300 的数字娱乐信用（适用于指定的流媒体和新闻订阅）。",
      "每年最高 $300 的Lululemon Credit。",
      "Uber One 会员($120 in statement credits for an Uber One membership)与 Uber Cash 优惠，每个月15 Uber cash, 12月份还有额外20的bonus，总价值 $200/年。",
      "每年最高 $200 的指定航空公司附加费信用（托运行李、机上收费等）。",
      "积分可 1:1 转换至多家航空与酒店常旅客计划，兑换价值高。",
    ],

    costBreakdown: [
      { description: "Annual Fee", amount: 895 },
      { description: "Fine Hotel and Resort Credit", amount: -600 },
      { description: "Saks Credit", amount: -100 },
      { description: "Uber Cash", amount: -200 },
      { description: "Airline Fee Credit", amount: -200 },
      { description: "Resy Credit", amount: -400 },
      { description: "Digital Entertainment Credit", amount: -300 },
      { description: "Lululemon Credit", amount: -300 },
      { description: "Final Annual Cost", amount: -1205 },
    ],
    whyKeep: [
      "如果你经常旅行，AMEX Platinum 是最有价值的高级信用卡之一。它提供全球贵宾室通行证、航班与酒店 5 倍积分，让旅程更加轻松舒适。",
      "通过 Fine Hotels + Resorts 或 The Hotel Collection 预订酒店可获得最高 $600 的酒店信用(每半年300)，并享受房型升级、延迟退房、双人早餐等高级礼遇。如果每年有高端酒店入住需求，这项福利就能覆盖大量年费成本。如果喜欢去Las Vegas旅游的话，Fine Hotels + Resorts 里面有很多不错的酒店选择。通常300刀的credit就可以订到MGM Grand或者Caesars Palace两天的房间，相当于信用卡就cover了房间的费用。",
      "每年有$400 Resy Dining Credit, 每个季度100刀。Resy.com上面有很多的餐厅，只要去餐厅吃饭的时候用这张卡付费就自动返回100了，这个是最容易用掉的benefit。",
      "每年有$100 Saks Fifth Avenue Credit, 每半年50刀。网上或者店里购物均可。",
      "对于喜欢Lululemon产品的用户，每一个季度有$75，全年共$300的Lululemon Credit，只要在Lululemon官网购买任何产品，并用该卡支付，就会自动返回，非常实用。",
      "该卡每年还提供数字娱乐订阅信用（最高 $300），如果你有订阅disney plus, youtube之类的服务， 该项福利非常实用，只需要用该信用卡支付月费，就会自动返回。再加上每年200 Uber Cash 与其他生活类优惠，几乎涵盖了日常餐饮、娱乐与出行消费，非常容易用满。",
      "对于经常托运行李或购买机上服务的旅客，$200 航空附加费信用非常实用，只要选择一间指定航空公司即可自动抵扣这些杂费。请注意这一项benefit并不cover机票购买的费用。这里有个特殊的trick，如果选择southwest作为指定航空公司，可以在southwest官网上选择购买单程小于100的机票，AMEX的系统对于小于100的购买都会自动认定为附加费，从而可以用这张卡的200刀credit来cover机票费用，如果机票用不上，可以refund成credit，请注意southwest的credit policy， 根据选择票的类型不同，credit会在购票时间6个月或一年过期，要按照自己的旅行计划安排，不要浪费了credit。对于喜欢united的朋友，可以通过购买united travelbank cash的方式来使用这200刀credit, 购买travelbank cash没有最低金额限制，可以根据自己的需要购买任意金额。",
      "Membership Rewards 积分非常灵活，可转点至多家航空与酒店伙伴，在兑换国际商务舱或高端酒店时能获得远高于现金返现的价值，是常旅客最推崇的积分体系之一。",
      "尽管年费高达 $895，但如果你能充分使用酒店信用、餐饮信用、数字娱乐信用、Uber 福利以及贵宾室等旅行权益，这张卡的实际价值远超年费，是高频旅行者值得长期持有的顶级卡之一。",
    ],
  },
].map(card => ({ ...card, ...sharedCardData[card.id] }))

export default cards
